import {UPDATE_CONFIG} from './types'

const initialState = {
  auth_token: '',
  owner: 'vacuumlabs',
  repo: 'bee'
}

export default function(prev_state = initialState, action) {
  switch (action.type) {
    case UPDATE_CONFIG: {
      const {auth_token, owner, repo} = action
      return {
        ...prev_state,
        auth_token,
        owner,
        repo,
      }
    }
    default: {
      return prev_state
    }
  }
}
